<template>
<div class="progress">
  <div :class="`progress-bar ${progressClass}`" :style="{width: progressPerc}"></div>
</div>
</template>

<script>
import Util from '../util.js';
import Dropzone from '../dropzone.js';

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    colorClass: {
      type: String,
      default: 'success'
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progressPerc() {
      return this.progress + '%';
    },
    progressClass() {
      var c = ['progress-bar-' + this.colorClass];
      if (this.active) {
        c.push('progress-bar-striped');
        c.push('active');
      }
      return c;
    }
  }
}
</script>
